import styled from "styled-components";

export const ContractTerminationContainer = styled.div`
  padding: 32px;
  background: ${({theme}) => theme.red};
  border-radius: 8px;
  border: unset;
  
  .message-wrapper{
    display: flex;
    .icon-box{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px !important;
      margin-right: 20px;
    }
    .message{
      > h1 {
        font-size: 19px;
        font-weight: 700;
        line-height: 23px;
        letter-spacing: 0.4px;
        text-align: left;
        color: ${({theme}) => theme.white};
        margin-bottom: 10px;
      }

      > p {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.3px;
        text-align: left;
        color: ${({theme}) => theme.white};
      }
      > button {
        margin-top: 15px;
        border-radius: 31px;
        background: transparent;
        border: 1px solid ${({theme}) => theme.white};
        color: ${({theme}) => theme.white};
        padding: 12px 24px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0.2px;
      }
    }
  }
`


